import React from 'react'
import { useSpinnerStyle, SPINNER_STYLES } from '../contexts/SpinnerContext';
import PrinterSpinner from './PrinterSpinner';

const DotsSpinner = () => (
    <div className="flex flex-col items-center justify-center mt-10 space-y-3">
        <div className="flex space-x-2" role="status">
            <span className="sr-only">Loading...</span>
            <div className="h-3 w-3 rounded-full dot-loader [animation-delay:-0.3s]"></div>
            <div className="h-3 w-3 rounded-full dot-loader [animation-delay:-0.15s]"></div>
            <div className="h-3 w-3 rounded-full dot-loader"></div>
        </div>
        <span className="text-sm text-gray-500 dark:text-gray-400">Loading</span>
    </div>
)

const Spinner = () => {
    const { spinnerStyle } = useSpinnerStyle();

    if (spinnerStyle === SPINNER_STYLES.PRINTER) {
        return <PrinterSpinner />;
    }
    return <DotsSpinner />;
}

export default Spinner;
